<template>
    <hts-popover
        v-model="show"
        max-width="805"
        placement="bottom-end">
        <template #reference>
            <button
                class="relative mr-6 mt-2"
                type="button">
                <hi-bell-icon class="text-main-text dark:text-main-text-dark text-zinc-800 w-7 h-7" />
                <span
                    v-if="cUnread > 0"
                    class="absolute top-[-4px] right-[-22px] bottom-0 left-0 object-right-top">
                    <div class="inline-flex items-center px-1.5 py-0.5 rounded-full text-xs font-semibold leading-4 bg-error-500 text-white">
                        {{ cUnread > 99 ? '99+' : cUnread }}
                    </div>
                </span>
            </button>
        </template>
        <div
            ref="notificationComponent"
            class="hts-notification"
            :class="cClass">
            <div class="hts-notification__header">
                <div class="hts-notification__header-filter">
                    <!--          <hts-form-button :color="filter === 'all' ? 'main' : 'white'" @click="onChangeFilter('all')"> -->
                    <!--            All -->
                    <!--          </hts-form-button> -->
                    <!--          <hts-form-button :color="filter === 'me' ? 'main' : 'white'" @click="onChangeFilter('me')"> -->
                    <!--            Only me -->
                    <!--          </hts-form-button> -->
                </div>
                <button
                    class="hts-notification__header-clear"
                    type="button"
                    @click="onClearAll">
                    <hi-bell-slash-icon class="w-6 h-6" />
                    {{ $t('labels.markAsRead') }}
                </button>
            </div>
            <div class="hts-notification__container">
                <div
                    v-for="(item, index) in cNotification"
                    :key="item._id">
                    <notification-item
                        :title="item.title"
                        :message="item.content"
                        :parent-message="item.parentContent"
                        :date="item.createdAt"
                        :user="item.createdBy"
                        :read="item.read"
                        :url="item.url"
                        is-admin
                        :query="item.query"
                        @update="(read: boolean) => onChangeRead(index, [item._id], item.read)"
                        @close="show = false" />
                </div>
            </div>
            <div
                v-if="isLoad"
                class="h-5 ml-5 w-full hts-loading__dot-fire bg-error-600" />
        </div>
    </hts-popover>
</template>
<script lang="ts" setup>
import type { INotification } from './notifications/model/notification'
import NotificationItem from './notifications/item.vue'
import colorSize from '~/components/color-size'

const props = defineProps({
  size: {
    type: String,
    default: 'default'
  },
  color: {
    type: String,
    default: 'default'
  }
})

const store = $store()
const isLoad = ref(false)
const notificationComponent = ref<HTMLElement>()
const skip = ref<number>(10)
const endLoad = ref<boolean>(false)
const show = ref(false)

const cNotification = computed(() => {
  return store.notification.getNotifications
})
const cUnread = computed(() => {
  return store.notification.getUnread
})

onMounted(() => {
  const element = notificationComponent.value
  if (element) {
    element.addEventListener('scroll', handleScroll)
  }
})

onUnmounted(() => {
  const element = notificationComponent.value
  if (element) {
    element?.removeEventListener('scroll', handleScroll)
  }
})

const handleScroll = () => {
  const element = notificationComponent.value
  if (element && element.scrollTop + element.clientHeight + 50 >= element.scrollHeight) {
    if (!endLoad.value && !isLoad.value) {
      loadMore()
    }
  }
}

const getStartRow = () => {
  return store.notification.countNotifications || 0
}

const onChangeRead = $lodash.debounce(async (index: number, id: string[], read: boolean) => {
  if (read) {
    return
  }

  const body = {
    ID: id,
    read
  }

  const result = await $api($urlSystem.notification.notificationChangeRead, { body })
  const success = $lodash.get(result, 'data.value.success')
  if (success) {
    await store.notification.changeRead(id)
  }
}, 100)

const onClearAll = $lodash.debounce(async () => {
  const result = await $api($urlSystem.notification.notificationClearAll)
  const success = $lodash.get(result, 'data.value.success')
  if (success) {
    store.notification.changeReadAll()
  }
}, 100)

const { cClass } = colorSize(props)

const loadMore = $lodash.debounce(async () => {
  isLoad.value = true
  const startRow = getStartRow()
  const body = {
    startRow: startRow.toString(),
    endRow: (startRow + skip.value).toString()
  }
  const result = await $api($urlSystem.notification.notificationList, { body: new URLSearchParams(body) })
  const success = $lodash.get(result, 'data.value.success')
  const res: any = $lodash.get(result, 'data.value.data')
  const notify = res.notification
  if (notify.length === 0) {
    endLoad.value = true
  }
  const unread = res.unread || 0
  store.notification.setUnread(unread)

  if (success) {
    store.notification.pushNotifications(notify)
  }
  isLoad.value = false
}, 100)
</script>
